document.addEventListener('DOMContentLoaded', function() {
  var recoverLink = document.getElementById('RecoverPassword');
  var hideRecoverLink = document.getElementById('HideRecoverPasswordLink');
  var loginForm = document.querySelector('.customer-auth__card:not(.customer-auth__card--recover)');
  var recoverForm = document.getElementById('RecoverPasswordForm');

  if (recoverLink) {
    recoverLink.addEventListener('click', function(e) {
      e.preventDefault();
      loginForm.style.display = 'none';
      recoverForm.style.display = 'block';
    });
  }

  if (hideRecoverLink) {
    hideRecoverLink.addEventListener('click', function(e) {
      e.preventDefault();
      recoverForm.style.display = 'none';
      loginForm.style.display = 'block';
    });
  }

  // Check URL hash
  if (window.location.hash === '#recover') {
    loginForm.style.display = 'none';
    recoverForm.style.display = 'block';
  }
});
